"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const importedModule = require('./theme');
const { theme } = importedModule;
exports.theme = theme;
